module.exports = __webpack_public_path__ + "email_logo.gif";